export default __webpack_public_path__ + "static/media/Weatherapp.bddfd384.png";